import { barChartItem } from './barChart';

export const awsChartItems: barChartItem[] = [
  {
    itemName: 'VPC',
    itemPercentage: 60
  },
  {
    itemName: 'Route 53',
    itemPercentage: 70
  },
  {
    itemName: 'ACM',
    itemPercentage: 90
  },
  {
    itemName: 'LB',
    itemPercentage: 70
  },
  {
    itemName: 'EC2',
    itemPercentage: 70
  },
  {
    itemName: 'RDS',
    itemPercentage: 70
  },
  {
    itemName: 'Aurora',
    itemPercentage: 70
  },
  {
    itemName: 'S3',
    itemPercentage: 80
  },
  {
    itemName: 'CloudFront',
    itemPercentage: 70
  },
  {
    itemName: 'WAF',
    itemPercentage: 70
  },
  {
    itemName: 'SES',
    itemPercentage: 70
  },
];
